import axios from 'axios';
import ChatBotEncodeDecodeService from './chatbot-encdec.service';
import EncodeDecodeType from '../enums/EncodeDecodeType';
import GlobalStoreService from './global-store.service';
import querystring from 'querystring';
import OnlineEncodeDecodeService from './online-encdec.service';
import GLOBAL_CONFIG from '../config/config';
import { globalConstants } from '../constants/globalConstants';
import UtilService from './util.service';
import { RefreshTokenService } from "./refresh-token.service";
import ChatBotApiService from './chatbot-api.service'
import { resolve } from 'path';

export default class CustomHTTPService {

    static post(url, data, config, encodeDecodeType, retry_count) {

        switch (encodeDecodeType) {
            case EncodeDecodeType.CHATBOT:
                _addDefaultChatBotConfig(config);
                _addChatBotTokenHeaders(config);
                return _chatBotPost(url, data, config, retry_count);
            case EncodeDecodeType.ONLINE:
                _addDefaultOnlineConfig(config);
                return _onlinePost(url, data, config);
            case EncodeDecodeType.DEFAULT:
                _addDefaultConfig(config);
                return _defaultPost(url, data, config);

            case EncodeDecodeType.URL_FORM_ENCODED:
                _addDefaultConfig(config);
                return _getUrlFormEncodedPost(url, data, config, retry_count);

        }
    }

    static get(url, config, encodeDecodeType, retry_count) {

        switch (encodeDecodeType) {
            case EncodeDecodeType.CHATBOT:
                _addDefaultChatBotConfig(config);
                _addChatBotTokenHeaders(config);
                return _chatBotGet(url, config, retry_count);
            case EncodeDecodeType.ONLINE:
                _addDefaultOnlineConfig(config);
                return _onlineGet(url, config);
            case EncodeDecodeType.DEFAULT:
                _addDefaultConfig(config);
                return _defaultGet(url, config);
        }
    }

}

const _addChatBotTokenHeaders = (config) => {
    if (!config) {
        config = {};
    }
    if (!config["headers"]) {
        config["headers"] = {};
    }

    config["headers"]["Airtel-Auth-Domain"] =
        GlobalStoreService.get("loggedInToken") ?
            GlobalStoreService.get("loggedInToken") :
            GlobalStoreService.get("basicToken");


    if (
        GlobalStoreService.get("isUserLoggedIn") &&
        (GlobalStoreService.get("primaryNumber") !== GlobalStoreService.get("currentNumber"))
    ) {
        config["headers"]["sso-number"] = GlobalStoreService.get("currentNumber");
    }

    if (GLOBAL_CONFIG.env === "local") {
        // config["headers"]["iv-user"] = "";
        config["headers"]["iv-user"] = "";
        // config["headers"]["iv-user"] = "";
    }
}

const _addDefaultConfig = (config) => {
    if (!config) {
        config = {};
    }
    if (!config["timeout"]) {
        config["timeout"] = 30000;
    }
    if (!config["headers"]) {
        config["headers"] = {};
    }
    if (!config["headers"]["Content-Type"]) {
        config["headers"]["Content-Type"] = "application/json";
    }
}

const _defaultGet = (url, config) => {
    return axios.get(url, config);
}

const _defaultPost = (url, data, config) => {
    return axios.post(url, data, config);
}



const _addDefaultChatBotConfig = (config) => {
    if (!config) {
        config = {};
    }
    if (!config["timeout"]) {
        config["timeout"] = 30000
    }
    if (!config["headers"]) {
        config["headers"] = {};
    }
    if (!config["headers"]["Content-Type"]) {
        config["headers"]["Content-Type"] = "application/json";
    }

}


const _chatBotGet = (url, config, retry_count) => {

    return new Promise((resolveChatBotGet, rejectChatBotGet) => {
        if (!retry_count) {
            retry_count = 0
        }
        axios.get(url, config).then(
            response => {
                if (!_checkWebsealAuthLogin(response)) {
                    if (retry_count < 1) {
                        if ((GlobalStoreService.get("APP_CONTEXT"))) {
                            //app case
                            RefreshTokenService.refreshLoginToken().then(
                                () => {
                                    retry_count = retry_count + 1
                                    resolveChatBotGet(CustomHTTPService.get(url, {}, EncodeDecodeType.CHATBOT, retry_count))
                                }
                            ).catch(
                                (err) => {
                                    rejectChatBotGet()
                                }
                            );
                        }
                        else {
                            //web case
                            if (GlobalStoreService.get("isUserLoggedIn")) {
                                GlobalStoreService.set("loginSessionExpired", true);
                            }
                            GlobalStoreService.set("loggedInToken", null);
                            GlobalStoreService.set("isUserLoggedIn", false);

                            RefreshTokenService.refreshBasicToken().then(
                                (result) => {
                                    retry_count = retry_count + 1
                                    resolveChatBotGet(CustomHTTPService.get(url, {}, EncodeDecodeType.CHATBOT, retry_count))
                                }
                            ).catch(
                                (err) => {
                                    rejectChatBotGet()
                                });
                        }
                    }
                    else {
                        rejectChatBotGet();
                    }
                }
                else {
                    resolveChatBotGet(ChatBotEncodeDecodeService.decode(response.data));
                }
            }, (error) => {
                if (retry_count < 1) {
                    if ((GlobalStoreService.get("APP_CONTEXT")) && (checkIfErrorUnauthorized(error) || !_checkWebsealAuthLogin(error.response))) {
                        //app case
                        RefreshTokenService.refreshLoginToken().then(
                            () => {
                                retry_count = retry_count + 1
                                resolveChatBotGet(CustomHTTPService.get(url, {}, EncodeDecodeType.CHATBOT, retry_count))
                            }
                        ).catch(
                            (err) => {
                                rejectChatBotGet()
                            }
                        );
                    }
                    else if ((!GlobalStoreService.get("APP_CONTEXT")) && (checkIfErrorUnauthorized(error) || !_checkWebsealAuthLogin(error.response))) {
                        //web case
                        if (GlobalStoreService.get("isUserLoggedIn")) {
                            GlobalStoreService.set("loginSessionExpired", true);
                        }
                        GlobalStoreService.set("loggedInToken", null);
                        GlobalStoreService.set("isUserLoggedIn", false);

                        RefreshTokenService.refreshBasicToken().then(
                            (result) => {
                                retry_count = retry_count + 1
                                resolveChatBotGet(CustomHTTPService.get(url, {}, EncodeDecodeType.CHATBOT, retry_count))
                            }
                        ).catch(
                            (err) => {
                                rejectChatBotGet()
                            });
                    }
                    else {
                        rejectChatBotGet()
                    }
                }
                else {
                    rejectChatBotGet()
                }
            }
        )

    })
}

const _getUrlFormEncodedPost = (url, data, config, retry_count) => {
    return new Promise((resolveUrlEncodedPost, rejectUrlEncodedPost) => {
        if (!retry_count) {
            retry_count = 0
        }
        axios.post(url, querystring.stringify(data), config).then(
            response => {
                if (!_checkWebsealAuthLogin(response)) {
                    if (retry_count < 1) {
                        if ((GlobalStoreService.get("APP_CONTEXT"))) {
                            //app case
                            RefreshTokenService.refreshLoginToken().then(
                                (result) => {
                                    retry_count = retry_count + 1
                                    resolveUrlEncodedPost(CustomHTTPService.post(url, data, config, EncodeDecodeType.URL_FORM_ENCODED, retry_count))
                                }
                            ).catch(
                                (err) => {
                                    retry_count = retry_count + 1
                                    rejectUrlEncodedPost();
                                });;
                        }
                        else {
                            //web case
                            if (GlobalStoreService.get("isUserLoggedIn")) {
                                GlobalStoreService.set("loginSessionExpired", true);
                            }
                            GlobalStoreService.set("loggedInToken", null);
                            GlobalStoreService.set("isUserLoggedIn", false);

                            RefreshTokenService.refreshBasicToken().then(
                                (result) => {
                                    retry_count = retry_count + 1
                                    resolveUrlEncodedPost(CustomHTTPService.post(url, data, config, EncodeDecodeType.URL_FORM_ENCODED, retry_count))
                                }
                            ).catch(
                                (err) => {
                                    retry_count = retry_count + 1
                                    rejectUrlEncodedPost()
                                });
                        }
                    }
                    else {
                        rejectUrlEncodedPost();
                    }
                }
                else {
                    resolveUrlEncodedPost(ChatBotEncodeDecodeService.decode(response.data));
                }
            }, (error) => {
                if (retry_count < 1) {
                    if ((GlobalStoreService.get("APP_CONTEXT")) && (checkIfErrorUnauthorized(error) || !_checkWebsealAuthLogin(error.response))) {
                        //app case
                        RefreshTokenService.refreshLoginToken().then(
                            (result) => {
                                retry_count = retry_count + 1
                                resolveUrlEncodedPost(CustomHTTPService.post(url, data, config, EncodeDecodeType.URL_FORM_ENCODED, retry_count))
                            }
                        ).catch(
                            (err) => {
                                retry_count = retry_count + 1
                                rejectUrlEncodedPost()
                            });;
                    }
                    else if ((!GlobalStoreService.get("APP_CONTEXT")) && (checkIfErrorUnauthorized(error) || !_checkWebsealAuthLogin(error.response))) {
                        //web case
                        if (GlobalStoreService.get("isUserLoggedIn")) {
                            GlobalStoreService.set("loginSessionExpired", true);
                        }
                        GlobalStoreService.set("loggedInToken", null);
                        GlobalStoreService.set("isUserLoggedIn", false);

                        RefreshTokenService.refreshBasicToken().then(
                            (result) => {
                                retry_count = retry_count + 1
                                resolveUrlEncodedPost(CustomHTTPService.post(url, data, config, EncodeDecodeType.URL_FORM_ENCODED, retry_count))
                            }
                        ).catch(
                            (err) => {
                                retry_count = retry_count + 1
                                rejectUrlEncodedPost();
                            });
                    }
                    else {
                        rejectUrlEncodedPost();
                    }
                }
                else {
                    rejectUrlEncodedPost()
                }

            }
        );
    })

}

const _checkWebsealAuthLogin = (response) => {
    if (response && response.headers && response.headers["content-type"] === "text/html") {
        return false;
    }
    return true;
}

const _chatBotPost = (url, data, config, retry_count) => {
    let final_url = `${ChatBotApiService.getBaseApiUrl()}${url}`
    return new Promise((resolveChatBoTPostRequest, rejectChatBotPostRequest) => {
        if (!retry_count) {
            retry_count = 0
        }
        axios.post(final_url, { message: ChatBotEncodeDecodeService.encode(data) }, config).then(
            response => {
                if (!_checkWebsealAuthLogin(response)) {
                    if (retry_count < 1) {
                        if ((GlobalStoreService.get("APP_CONTEXT"))) {
                            //app case
                            RefreshTokenService.refreshLoginToken().then(
                                (result) => {
                                    retry_count = retry_count + 1
                                    resolveChatBoTPostRequest(CustomHTTPService.post(url, data, config, EncodeDecodeType.CHATBOT, retry_count))
                                }
                            ).catch(
                                (err) => {
                                    retry_count = retry_count + 1
                                    rejectChatBotPostRequest()
                                });;
                        }
                        else {
                            //web case
                            if (GlobalStoreService.get("isUserLoggedIn")) {
                                GlobalStoreService.set("loginSessionExpired", true);
                            }
                            GlobalStoreService.set("loggedInToken", null);
                            GlobalStoreService.set("isUserLoggedIn", false);

                            RefreshTokenService.refreshBasicToken().then(
                                (result) => {
                                    retry_count = retry_count + 1
                                    resolveChatBoTPostRequest(CustomHTTPService.post(url, data, {}, EncodeDecodeType.CHATBOT, retry_count))
                                }
                            ).catch(
                                (err) => {
                                    retry_count = retry_count + 1
                                    rejectChatBotPostRequest()
                                });
                        }
                    }
                    else {
                        rejectChatBotPostRequest()
                    }
                }
                else {
                    if (response.headers['content-type'] === "application/pdf") {
                        // console.log(response)
                        resolveChatBoTPostRequest(response.data)
                    }
                    else
                        resolveChatBoTPostRequest(ChatBotEncodeDecodeService.decode(response.data));
                }
            }, (error) => {
                if (retry_count < 1) {
                    if ((GlobalStoreService.get("APP_CONTEXT")) && (checkIfErrorUnauthorized(error) || !_checkWebsealAuthLogin(error.response))) {
                        RefreshTokenService.refreshLoginToken().then(
                            (result) => {
                                retry_count = retry_count + 1
                                resolveChatBoTPostRequest(CustomHTTPService.post(url, data, config, EncodeDecodeType.CHATBOT, retry_count))
                            }
                        ).catch(
                            (err) => {
                                rejectChatBotPostRequest()
                            });;
                    }
                    else if ((!GlobalStoreService.get("APP_CONTEXT")) && (checkIfErrorUnauthorized(error) || !_checkWebsealAuthLogin(error.response))) {
                        if (GlobalStoreService.get("isUserLoggedIn")) {
                            GlobalStoreService.set("loginSessionExpired", true);
                        }
                        GlobalStoreService.set("loggedInToken", null);
                        GlobalStoreService.set("isUserLoggedIn", false);

                        RefreshTokenService.refreshBasicToken().then(
                            (result) => {
                                retry_count = retry_count + 1
                                resolveChatBoTPostRequest(CustomHTTPService.post(url, data, {}, EncodeDecodeType.CHATBOT, retry_count))
                            }
                        ).catch(
                            (err) => {
                                retry_count = retry_count + 1
                                rejectChatBotPostRequest()
                            });
                    }
                    else {
                        rejectChatBotPostRequest()
                    }
                }
                else {
                    rejectChatBotPostRequest()
                }
            }
        );
    })
}


const _onlineGet = (url, config) => {
    return axios.get(url, config).then(
        response => {
            return response;
        }
    )
}

const _onlinePost = (url, data, config) => {
    return axios.post(url, data, config).then(
        response => {
            return response;
        }
    );
}

const _addDefaultOnlineConfig = (config) => {
    if (!config) {
        config = {};
    }
    if (!config["timeout"]) {
        config["timeout"] = 30000
    }
    if (!config["headers"]) {
        config["headers"] = {};
    }
    config["headers"]["Content-Type"] = "application/json";
    if (!config["headers"]["adsHeader"]) {
        const key = OnlineEncodeDecodeService._generateEncryptionKeyForOTP();
        config["headers"]["adsHeader"] = key;
    }
}

const checkIfErrorUnauthorized = (error) => {
    if (error && error.response &&
        error.response.status &&
        error.response.status.toString().startsWith("4") &&
        error.response.status.toString() !== "404" && error.response.status.toString() !== "400") {
        return true
    }
    else {
        return false
    }
}


// WEBPACK FOOTER //
// ./src/services/custom-http.service.js